import { render, staticRenderFns } from "./LegalInfo.vue?vue&type=template&id=b8f5dab8&"
import script from "./LegalInfo.vue?vue&type=script&lang=js&"
export * from "./LegalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports